// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__3x+0A","link":"footer_link__5DWMt"};